// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__6Fg++","active":"Nav_active__TaooJ"};